import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const ID = 'pause-control';
export const PauseControlIcon = ({ fill = 'white', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id={ID} stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <rect id="Background" x="0" y="0" width="24" height="24"></rect>
                    <g transform="translate(4.000000, 2.000000)" fillRule="nonzero" id="Path" className={fillStyles}>
                        <path d="M6,17.2142752 C6,18.7527044 4.65676369,20 3,20 L3,20 C1.34323631,20 0,18.7527044 0,17.2142752 L0,2.78572479 C0,1.24729557 1.34323631,0 3,0 L3,0 C4.65676369,0 6,1.24729557 6,2.78572479 L6,17.2142752 Z"></path>
                        <path d="M16,17.2142752 C16,18.7527044 14.6567637,20 13,20 L13,20 C11.3432363,20 10,18.7527044 10,17.2142752 L10,2.78572479 C10.0004524,1.24729557 11.3436887,0 13,0 L13,0 C14.6567637,0 16,1.24729557 16,2.78572479 L16,17.2142752 Z"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};
